import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Image from '@/components/base/Image'
import Motion from '@/components/base/Motion'

import { textOnImage } from './animations'
import { cn } from '@/lib/utils'
import { WPImage, WPPageData } from '@/types'

export type SingleImgProps = HTMLAttributes<HTMLElement> &
  Partial<{
    className: string
    item: WPImage
    theme: WPPageData['acf']['theme']
    is_in_lightbox: boolean
    alignment: {
      use_contain: boolean
      position: 'left' | 'right'
    }
  }>

const SingleImg = ({
  className,
  item,
  alignment,
  theme,
  is_in_lightbox = true,
  ...props
}: SingleImgProps) => {
  return (
    <Motion animation={textOnImage}>
      {(motionRef) => (
        <section
          ref={motionRef}
          className={cn([
            'relative h-svh',
            {
              'bg-white': theme === 'light',
              'bg-dark-600': theme === 'dark'
            },
            className
          ])}
          {...props}
        >
          <Container className="absolute left-0 top-0 z-10 h-full w-full">
            <Grid className="relative h-full">
              <div
                className={cn([
                  'relative z-10',
                  {
                    'col-span-4 md:col-span-6 lg:col-span-5':
                      alignment?.use_contain,
                    'col-span-4 md:col-span-6 lg:col-span-12':
                      !alignment?.use_contain,
                    'lg:col-start-8':
                      alignment?.use_contain && alignment?.position === 'right',
                    'lg:col-start-1':
                      alignment?.use_contain && alignment?.position === 'left'
                  }
                ])}
                data-gallery-wrapper={is_in_lightbox}
              >
                <Image
                  source={item}
                  fill
                  fit="cover"
                  className="h-full w-full"
                  data-motion-image
                  data-gallery={is_in_lightbox}
                />
              </div>
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default SingleImg
